import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	index: number;
	title: string;
	isOpen: boolean;
	toggle: () => void;
}

interface DesignerPanelSectionComponentInterface {
	Element: HTMLDivElement;
	Args: Args;
	Blocks: { default: [] }; // this is needed for yield
}

const DesignerPanelSectionComponent: TOC<DesignerPanelSectionComponentInterface> = <template>
	<div class="section section--{{@index}} {{if @isOpen 'section--open'}}">

		<div role="button" class="section__header" {{on "click" @toggle}}>
			<span class="section__header__title">{{@title}}</span>
			<div class="section__header__action">
				<CommonUiIconComponent @name="ChevronDown" @size="sm" />
			</div>
		</div>

		{{#if (has-block)}}
			<div class="section__content">
				{{yield}}
			</div>
		{{/if}}

	</div>
</template>;

export default DesignerPanelSectionComponent;
